module.exports = __webpack_public_path__ + "static/media/bg-desk.8e671b79.svg";